import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackWithPlausible } from '../../utils/plausible';

export const useTrackPageView = () => {
  if (process.env.REACT_APP_ENABLE_TRACKING !== 'true') {
    return;
  }
  const location = useLocation();

  function cutAfterTrip(path: string): string {
    const tripIndex = path.indexOf('/trip/');
    if (tripIndex === -1) return path;
    return path.slice(0, tripIndex + '/trip/'.length) + 'redacted';
  }

  useEffect(() => {
    const sanitizedPath = location.pathname.replaceAll(/\/[0-9a-fA-F-]{20,}/g, '/:id');
    const redactedPath = cutAfterTrip(sanitizedPath);
    const fullUrl = `${window.location.origin}${redactedPath}${location.search}${location.hash}`;
    console.log('tracking ' + fullUrl);
    trackWithPlausible('pageview', { url: fullUrl });
  }, [location.pathname]);
};
